/* ============================================================
   HIT: a página de produto no navegador (direção de 19/10/2026, DIRECAO-CARD-PDP.md §5 a §6). Troca de cor, de empunhadura/tamanho e de
   foto sem recarregar, com a variante na URL. O Liquid (sections/main-product e os snippets) desenha o estado inicial; aqui só se atualiza
   o que já está na página, no lugar. Nenhuma gaveta de tamanho, nenhum "Voltar", nenhum contador de foto.
     window.HitProduto = { pronto, aoAdicionar(fn), estado(), variante(), foto(), passo(d), irPara(i) }
   DADOS. Tudo vem do <script type="application/json" id="hit-produto-dados"> (contrato no main-product): opções, variantes (id, opções,
   estoque, preço e riscado em centavos), fotos, as fotos de cada cor (porCor), os textos do locale e a parcela. Os textos de compra
   (adicionando, adicionado, falhaAdicionar), o aviso (aviseMeMensagem), o Pix, o WhatsApp e a raiz vêm do HitConfig (theme.liquid).
   ESTADOS (data-estado do #compra e dos botões): comprar, escolha (falta a empunhadura/tamanho: o Comprar continua clicável e mostra o
   erro) e indisponivel (o produto todo, ou a combinação escolhida sem estoque: o Comprar sai e entra o Avise-me, "Indisponível" e o link
   "Ver outras raquetes"). UMA regra para o alerta e a ação (esgotadoAqui; no Liquid, esgotado_aqui do main-product).
   COMPRAR. O rótulo é sempre "Comprar"; o botão não é desativado: o pedido em curso só põe aria-busy. Os dois botões (o do resumo e o da
   barra do celular) disparam o MESMO pedido, um por vez. Sucesso abre a gaveta da sacola; falha fica na região #compra-anuncio (e no aviso).
   O pedido à sacola é do assets/hit-sacola-produto.js, que registra o tratador com HitProduto.aoAdicionar(fn).
   SEM EMPUNHADURA. Comprar sem ela: o erro "Escolha a empunhadura" aparece no grupo, a página rola até ele de uma vez, o foco vai ao grupo
   (tabindex -1) e a borda de 2 px de --erro some na primeira escolha, sem rolar de volta. Vindo de um aro que não tem a empunhadura
   (?escolha=empunhadura), só o texto aparece: sem rolagem nem contorno.
   AVISE-ME. O link por empunhadura e o botão são refeitos na troca de cor (avisaOp, avisaBotao): a mesma mensagem do Liquid
   (snippets/opcoes-produto e sections/main-product, href_avise): o nome, o aro, a cor e a empunhadura, e o endereço da página com UTM.
   ============================================================ */
(function () {
  'use strict';
  if (window.HitProduto) return;
  const el = document.getElementById('hit-produto-dados');
  if (!el) return;
  let D;
  try { D = JSON.parse(el.textContent); } catch (e) { console.error('hit-produto.js: o JSON #hit-produto-dados não abre', e); return; }
  const PE = window.HitPecas;
  if (!PE) { console.error('hit-produto.js: falta o hit-pecas.js (HitPecas), que tem de carregar antes'); return; }
  const $ = (s, r) => (r || document).querySelector(s), $$ = (s, r) => [...(r || document).querySelectorAll(s)];
  const E = PE.E, brl = (c) => PE.brl(c / 100), T = D.textos, C = window.HitConfig || {}, CT = C.textos || {};
  const preenche = (m, o) => String(m).replace(/\{(\w+)\}/g, (x, k) => (Object.prototype.hasOwnProperty.call(o, k) ? String(o[k]) : x));
  const REDUZ = window.matchMedia('(prefers-reduced-motion: reduce)');
  const IC = D.ic, IT = D.it, CORES = IC >= 0 ? D.opcoes[IC].v : [], TODAS = D.fotos.map((f, i) => i);
  const porId = (id) => D.variantes.find((v) => v.id === id) || null;
  const REF = porId(D.ref) || D.variantes[0], BASE = porId(D.sel) || REF;
  const S = { cor: D.cor, tam: D.tam, gi: 0, galCor: D.cor, pendente: false, destaque: false, ocupado: false };
  let tratador = null;

  /* O preço da página é do hit-pecas.js (precoPdpHtml), a MESMA marcação de snippets/pdp-preco.liquid (o Pix é o preço principal; apontamentos de 28/10).
     Os textos vêm do HitConfig; a parcela, do locale da página (produto.parcela) e dos dados do main-product, como no Liquid. Sem o módulo configurado
     (HitConfig ausente), o erro vai ao console, a compra continua e a troca de variante escreve o preço simples da variante (precoSimples):
     o preço da variante anterior nunca fica na tela. */
  let PEI = null;
  try {
    PEI = PE.criar({
      parcela: { vezes: D.parcela && D.parcela.vezes, minima: (Number(D.parcela && D.parcela.minimaC) || 0) / 100 },
      textos: Object.assign({}, CT, { parcela: T.parcela }), pix: C.pix,
    });
  } catch (e) { console.error('hit-produto.js: o preço não pôde ser configurado (HitPecas.criar)', e); }

  /* ---------- variantes ---------- */
  const varDe = (cor, tam) => D.variantes.find((v) => v.o.every((x, i) => (i === IC ? x === cor : i === IT ? x === tam : x === BASE.o[i]))) || null;
  const atual = () => (IT >= 0 && !S.tam ? null : varDe(S.cor, S.tam));
  const tem = (cor, tam) => { const v = varDe(cor, tam); return !!(v && v.d); };
  const coresComTam = (tam) => (CORES.length > 1 && tam ? CORES.filter((c) => tem(c, tam)) : []);
  /* a mesma conta do main-product (parcela_c), do snippets/preco.liquid e do hit-pecas.js: mudou aqui, mude lá */
  function parcela(c) {
    const vezes = Math.round(Number(D.parcela && D.parcela.vezes) || 0), min = Math.round(Number(D.parcela && D.parcela.minimaC) || 0);
    if (!(vezes > 0 && min > 0 && c >= vezes * min)) return null;
    return preenche(T.parcela, { vezes, valor: brl(Math.floor((2 * c + vezes) / (2 * vezes))) });
  }
  /* UMA regra para o alerta e a ação: o produto tem estoque, a empunhadura/tamanho está escolhido (ou não há opção) e a variante falta */
  const esgotadoAqui = () => { const v = atual(); return !!D.disponivel && (IT < 0 || !!S.tam) && !(v && v.d); };
  function estado() {
    if (!D.disponivel || esgotadoAqui()) return 'indisponivel';
    return IT >= 0 && !S.tam ? 'escolha' : 'comprar';
  }

  /* ---------- Avise-me (WhatsApp): a mesma conta de snippets/whatsapp-url.liquid, igual a do hit-pecas.js ---------- */
  const codifica = (t) => encodeURIComponent(t).replace(/[!'()*~]/g, (c) => '%' + c.charCodeAt(0).toString(16).toUpperCase());
  function urlAviso(partes) {
    const dig = String(C.whatsapp || '').replace(/\D/g, ''), raiz = typeof C.raiz === 'string' ? C.raiz : '';
    if (!dig || !raiz) return '';
    const liga = D.url.indexOf('?') >= 0 ? '&' : '?';
    const texto = partes.join('').trim() + ` ${raiz}${D.url}${liga}utm_source=site&utm_medium=whatsapp&utm_campaign=avise_me`;
    return `https://wa.me/${dig}?text=${codifica(texto)}`;
  }
  const baseAviso = () => [`${CT.aviseMeMensagem} ${D.titulo}`, D.aro ? ` · ${D.aro}` : ''];
  const avisaOp = (cor, tam) => urlAviso([...baseAviso(), cor ? ` · ${cor}` : '', ` · ${D.nomeMin} ${tam}`]);
  const avisaBotao = () => urlAviso(esgotadoAqui() ? [...baseAviso(), S.cor ? ` · ${S.cor}` : '', S.tam ? ` · ${D.nomeMin} ${S.tam}` : ''] : baseAviso());

  /* ---------- fotos ---------- */
  // as fotos da cor (porCor, do main-product: as próprias e depois as comuns); uma cor só, ou cor sem foto de variante, todas
  const fotosDa = (cor) => (CORES.length > 1 && D.porCor[cor] && D.porCor[cor].length ? D.porCor[cor] : TODAS);
  const foto = (k, w) => { const s = D.fotos[k].s; return `${s}${s.indexOf('?') < 0 ? '?' : '&'}width=${w}`; };
  const altDe = (cor) => (cor ? preenche(T.fotoAlt, { titulo: D.titulo, cor }) : D.titulo);

  /* ---------- desenho: cada parte no lugar ---------- */
  // sem o módulo de preço (PEI nulo) ou sem preço na variante: o preço normal dela, com o riscado, como o pdp-preco.liquid sem Pix e sem parcela; ou o aviso
  const precoValido = (v) => typeof v.p === 'number' && Number.isFinite(v.p) && v.p >= 0;
  function precoSimples(v) {
    if (!precoValido(v)) return `<p class="par">${E(CT.precoIndisponivel || 'Preço indisponível')}</p>`;
    const de = v.c && v.c > v.p ? ` <span class="preco-ref"><s>${E(brl(v.c))}</s></span>` : '';
    return `<p class="preco-linha num"><span class="p">${E(brl(v.p))}</span>${de}</p>`;
  }
  function renderPreco() {
    const box = $('#preco');
    if (!box) return;
    const v = atual() || REF;
    // a página e a barra de compra do celular saem da MESMA conta (HitPecas.precoPdpHtml); a barra pede o apoio compacto (segundo argumento)
    const dados = { preco: v.p / 100, precoDe: v.c && v.c > v.p ? v.c / 100 : null };
    const html = (barra) => (PEI && precoValido(v) ? PEI.precoPdpHtml(dados, barra) : '') || precoSimples(v);
    box.innerHTML = html(false);
    const barra = $('.barra-preco');
    if (barra) barra.innerHTML = html(true);
    const ben = $('[data-ben-parcela]');
    if (ben) ben.hidden = !parcela(v.p);
    renderFrete(v);
  }
  /* A frase do frete abaixo do Comprar (snippets/pdp-servico): do valor do ajuste "Frete grátis a partir de" (D.frete.limiteC, em centavos, a mesma conta
     do snippets/frete-gratis-limite) para cima diz que é grátis; abaixo dele, ou sem valor válido, o texto de sempre. O preço da variante nova refaz a frase. */
  function renderFrete(v) {
    const p = $('[data-frete]');
    const lim = Math.round(Number(D.frete && D.frete.limiteC) || 0);
    if (!p || !T.freteGratis || !T.freteFinalizar) return;
    p.textContent = lim > 0 && precoValido(v) && v.p >= lim ? T.freteGratis : T.freteFinalizar;
  }
  // a miniatura da cor na pílula do alerta: a capa dela (a primeira das fotos da cor); produto sem foto, nenhuma
  const miniDa = (c) => {
    const k = fotosDa(c)[0];
    return k === undefined ? '' : `<img class="mini" src="${E(foto(k, 96))}" alt="" width="32" height="32">`;
  };
  function renderAlerta() {
    const box = $('.alerta-vivo');
    if (!box) return;
    if (!(IT >= 0 && CORES.length > 1 && esgotadoAqui())) { box.replaceChildren(); return; } // sem outra cor a oferecer, o alerta não diz nada além do "Indisponível"
    const alt = coresComTam(S.tam), tam = S.tam;
    const titulo = S.cor ? preenche(T.alertaTitulo, { tam, cor: S.cor }) : preenche(T.alertaTituloSemCor, { tam });
    const pills = alt.map((c) => `<button class="pil" type="button" data-cor="${E(c)}">${miniDa(c)}`
      + `<span class="pt"><b>${E(c)}</b><small>${E(preenche(T.temO, { tam }))}</small></span></button>`).join('');
    const texto = E(alt.length ? preenche(T.alertaExiste, { tam }) : T.alertaNaoExiste);
    box.innerHTML = `<section class="alerta" id="alerta"><p><b>${E(titulo)}</b> ${texto}</p>${alt.length ? `<div class="alt">${pills}</div>` : ''}</section>`;
  }
  /* o texto da pílula e, se faltar o tamanho, " <small>sem o 43</small>" (a miniatura da cor fica) */
  function textoDaPilula(b, texto, sem) {
    const img = $('img', b);
    b.replaceChildren(...(img ? [img] : []), document.createTextNode(texto));
    b.classList.toggle('tr', sem);
    if (sem) { const sm = document.createElement('small'); sm.textContent = preenche(T.semO, { tam: S.tam }); b.append(' ', sm); }
  }
  function renderCores() {
    const bl = $('[data-papel="cor"]');
    if (!bl) return;
    $('.rot', bl).textContent = preenche(T.corEscolhida, { cor: S.cor });
    $$('.pil', bl).forEach((b) => {
      const c = b.dataset.valor;
      b.setAttribute('aria-pressed', String(c === S.cor));
      textoDaPilula(b, c, !!S.tam && !tem(c, S.tam));
    });
  }
  /* a escala de empunhadura/tamanho: pressionada, indisponível (continua selecionável), o link "Avise-me" de cada uma e o erro do grupo */
  function renderTam() {
    const g = $('#grupo-tam');
    if (!g) return;
    $$('.opt-c', g).forEach((c) => {
      const b = $('.opt', c), t = b.dataset.valor, ok = tem(S.cor, t);
      b.setAttribute('aria-pressed', String(t === S.tam));
      if (ok) b.removeAttribute('aria-disabled'); else b.setAttribute('aria-disabled', 'true');
      let sr = $('.sr', b);
      if (!ok && !sr) { sr = document.createElement('span'); sr.className = 'sr'; sr.textContent = ' ' + T.indisponivelSr; b.append(sr); }
      else if (ok && sr) sr.remove();
      const a = $('.avise-op', c);
      if (a) { a.hidden = ok; const u = avisaOp(S.cor, t); if (u) a.setAttribute('href', u); }
    });
    const erro = $('#erro-tam');
    if (erro) erro.hidden = !S.pendente;
    if (S.pendente) g.setAttribute('aria-describedby', 'erro-tam'); else g.removeAttribute('aria-describedby');
    g.classList.toggle('pendente', S.destaque);
  }
  /* os links do aro (e das filas de quadra/gênero): o ?variant= da empunhadura/tamanho novo (data-tams, snippets/pdp-aro-link) */
  function renderVersoes() {
    $$('.seletor [data-tams]').forEach((a) => {
      let lista = [];
      try { lista = JSON.parse(a.dataset.tams); } catch (e) { return; }
      const doTam = S.tam ? lista.filter((x) => x[0] === S.tam) : [], v = doTam.find((x) => x[2]) || doTam[0];
      if (a.classList.contains('aro-op')) a.setAttribute('href', a.dataset.url + (v ? `?variant=${v[1]}` : S.tam ? '?escolha=empunhadura' : ''));
      else {
        const txt = a.firstChild && a.firstChild.nodeType === 3 ? a.firstChild.textContent : a.textContent;
        textoDaPilula(a, txt, !!S.tam && !doTam.some((x) => x[2]));
        a.setAttribute('href', a.dataset.url + (v ? `?variant=${v[1]}` : ''));
      }
    });
  }
  /* a ação: Comprar ou Avise-me (o do resumo e o da barra juntos), "Indisponível" e o link das outras raquetes */
  function renderAcao() {
    const e = estado(), ind = e === 'indisponivel', bar = $('#compra'), href = avisaBotao();
    if (bar) bar.dataset.estado = e;
    $$('[data-comprar]').forEach((b) => {
      b.hidden = ind;
      if (S.ocupado) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    });
    $$('[data-avise]').forEach((a) => { a.hidden = !ind; if (href) a.setAttribute('href', href); });
    $$('[data-indisp], [data-ver-outras]').forEach((n) => { n.hidden = !ind; });
  }

  /* a foto nova entra por baixo e a anterior, por cima, some em --dur-foto (180 ms, hit-produto.css) com a curva --ease. Cada troca tem uma
     ficha: a seguinte cancela a anterior e tira a velha, então nunca sobra .velha nem animação. Com movimento reduzido, nada */
  let ficha = 0, cruza = null;
  const tempoCss = (no, nome, t = getComputedStyle(no).getPropertyValue(nome).trim()) => (parseFloat(t) || 0) * (/ms$/.test(t) ? 1 : 1000);
  function paraCruza(main) {
    ficha += 1;
    if (cruza) { cruza.cancel(); cruza = null; }
    $$('img.velha', main).forEach((o) => o.remove());
  }
  function cruzaFoto(main, img, poe) {
    paraCruza(main);
    if (REDUZ.matches || !img.getAttribute('src') || typeof img.animate !== 'function') { poe(); return; }
    const n = ficha, o = document.createElement('img');
    o.className = 'gal-foto velha'; o.alt = ''; o.src = img.currentSrc || img.getAttribute('src');
    main.prepend(o);
    poe();
    const fim = () => { if (n === ficha) { o.remove(); cruza = null; } };
    const some = () => {
      if (n !== ficha) return;
      const curva = getComputedStyle(main).getPropertyValue('--ease').trim() || 'ease';
      cruza = o.animate([{ opacity: 1 }, { opacity: 0 }], { duration: tempoCss(main, '--dur-foto'), easing: curva, fill: 'both' });
      cruza.finished.then(fim, fim);
    };
    (typeof img.decode === 'function' ? img.decode() : Promise.resolve()).then(some, some);
  }
  const fotoAtual = () => {
    const fs = fotosDa(S.cor), i = Math.min(Math.max(S.gi, 0), Math.max(fs.length - 1, 0));
    return { i, n: fs.length, k: fs[i], lista: fs, alt: altDe(S.cor), src: (w) => (fs.length ? foto(fs[i], w) : '') };
  };
  function renderGaleria() {
    const main = $('#galmain');
    if (!main) return;
    const fs = fotosDa(S.cor), n = fs.length;
    if (!n) return;
    const mudouCor = S.galCor !== S.cor;
    S.gi = Math.min(Math.max(S.gi, 0), n - 1);
    const k = fs[S.gi], f = D.fotos[k];
    const larguras = String(main.dataset.larguras || '').split(',').map(Number).filter((w) => w > 0); // as larguras e o sizes vêm do snippets/galeria
    let img = $('.gal-foto:not(.velha)', main);
    if (!img) { img = document.createElement('img'); img.className = 'gal-foto'; img.draggable = false; main.prepend(img); }
    if (main.dataset.sizes) img.setAttribute('sizes', main.dataset.sizes);
    const src = foto(k, larguras[0]);
    if (img.getAttribute('src') !== src) {
      cruzaFoto(main, img, () => {
        img.setAttribute('src', src);
        img.setAttribute('srcset', larguras.map((w) => `${foto(k, w)} ${w}w`).join(', '));
        if (f.w && f.h) { img.width = f.w; img.height = f.h; }
      });
    }
    img.alt = altDe(S.cor);
    S.galCor = S.cor;
    const barra = $('.gal-barra'), th = $('.gal-th');
    if (barra) barra.hidden = n < 2;
    if (th && mudouCor) {
      th.innerHTML = n < 2 ? '' : fs.map((x, j) => `<button type="button" data-gal-i="${j}" aria-label="${E(preenche(T.fotoN, { numero: j + 1 }))}">`
        + `<img src="${E(foto(x, 160))}" alt="" loading="lazy" width="72" height="90"></button>`).join('');
    }
    $$('[data-gal-i]', th || document).forEach((b, j) => { if (j === S.gi) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
    document.dispatchEvent(new CustomEvent('hit:produto-foto', { detail: { i: S.gi, n, k } }));
  }
  function renderUrl() {
    const v = atual(), u = new URL(location.href);
    if (v) u.searchParams.set('variant', String(v.id)); else u.searchParams.delete('variant');
    if (S.tam) u.searchParams.delete('escolha');
    if (u.href !== location.href) history.replaceState(history.state, '', u.href);
  }
  function render() { renderPreco(); renderAlerta(); renderCores(); renderTam(); renderVersoes(); renderAcao(); renderGaleria(); renderUrl(); }

  /* ---------- ações ---------- */
  function escolhe(cor, tam) {
    if (cor !== S.cor) S.gi = 0;
    if (tam !== S.tam) { S.pendente = false; S.destaque = false; } // escolheu: o erro e o contorno saem, sem rolar de volta
    S.cor = cor; S.tam = tam;
    render();
  }
  function passo(d) {
    const n = fotosDa(S.cor).length;
    if (n < 2) return;
    S.gi = (S.gi + d + n) % n;
    renderGaleria();
  }
  function irPara(i) { if (i >= 0 && i < fotosDa(S.cor).length) { S.gi = i; renderGaleria(); } }
  /* Comprar sem a empunhadura: o erro no grupo, a rolagem imediata (scroll-margin-top no CSS), o foco no grupo e o contorno de --erro */
  function pedeEscolha() {
    const g = $('#grupo-tam');
    S.pendente = true; S.destaque = true;
    renderTam();
    if (!g) return;
    g.scrollIntoView({ block: 'start', behavior: 'instant' });
    g.focus({ preventScroll: true });
  }
  /* a região viva única da compra (#compra-anuncio, no resumo): o texto de sucesso e de espera só o leitor de tela lê; o de falha aparece */
  function anuncia(texto, visivel) {
    const r = $('#compra-anuncio');
    if (!r) return;
    r.textContent = '';
    r.textContent = texto || '';
    r.classList.toggle('visivel', !!visivel && !!texto);
  }
  let relogio = 0;
  function toast(msg) {
    const t = document.getElementById('toast');
    if (!t || !msg) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(relogio);
    relogio = setTimeout(() => { t.hidden = true; }, 3600);
  }
  async function adicionar(btn) {
    const v = atual();
    if (S.ocupado || !v || !v.d) return;
    btn.dispatchEvent(new CustomEvent('hit:produto-adicionar', { bubbles: true, detail: { variante: v.id } }));
    if (!tratador) return;
    S.ocupado = true;
    anuncia(CT.adicionando, false);
    renderAcao();
    let ok = false;
    try { ok = (await tratador({ variante: v.id, quantidade: 1 })) === true; } catch (e) { console.error('hit-produto.js: o tratador do Comprar falhou', e); }
    S.ocupado = false;
    renderAcao();
    if (!ok) { anuncia(CT.falhaAdicionar, true); toast(CT.falhaAdicionar); return; }
    anuncia(CT.adicionado, false);
    const G = window.HitGaveta;
    if (!(G && G.tem('sacola') && G.abrir('sacola', btn))) location.assign(D.carrinho);
  }
  function comprar(btn) {
    const e = estado();
    if (e === 'escolha') pedeEscolha();
    else if (e === 'comprar') adicionar(btn);
  }

  document.addEventListener('click', (ev) => {
    const t = ev.target;
    if (!t || !t.closest || ev.defaultPrevented) return;
    let b = t.closest('[data-papel="cor"] .pil');
    if (b) { escolhe(b.dataset.valor, S.tam); return; }
    if ((b = t.closest('#alerta .alt .pil'))) {
      escolhe(b.dataset.cor, S.tam);
      const btn = $('.buy [data-comprar]');
      if (btn) btn.focus({ preventScroll: true });
      return;
    }
    if ((b = t.closest('#grupo-tam .opt'))) { escolhe(S.cor, b.dataset.valor); return; }
    if ((b = t.closest('[data-comprar]'))) { comprar(b); return; }
    if ((b = t.closest('[data-gal]'))) { passo(Number(b.dataset.gal)); return; }
    if ((b = t.closest('[data-gal-i]'))) { irPara(Number(b.dataset.galI)); }
  });

  /* setas do teclado entre as opções de uma fila com data-setas (dão a volta) */
  document.addEventListener('keydown', (ev) => {
    if (ev.key !== 'ArrowRight' && ev.key !== 'ArrowLeft') return;
    if (ev.altKey || ev.metaKey || ev.ctrlKey || ev.shiftKey) return; // Alt+seta é voltar no navegador; com modificador, a seta não é nossa
    const f = ev.target && ev.target.closest && ev.target.closest('[data-setas]');
    if (!f) return;
    const OP = '.pil, .aro-op, .opt', l = $$(OP, f), i = l.indexOf(ev.target.closest(OP));
    if (i < 0) return;
    ev.preventDefault();
    l[(i + (ev.key === 'ArrowRight' ? 1 : -1) + l.length) % l.length].focus();
  });

  /* arrasto na foto grande: 40 px para um lado troca a foto */
  const LIMIAR = 40, gm = $('#galmain');
  if (gm) {
    let x0 = null;
    gm.addEventListener('pointerdown', (ev) => {
      if (ev.button !== 0 || ev.target.closest('button')) return;
      x0 = ev.clientX;
      try { gm.setPointerCapture(ev.pointerId); } catch (e) { /* sem captura, o pointerup ainda chega dentro da foto */ }
    });
    gm.addEventListener('pointerup', (ev) => {
      const dx = x0 === null ? 0 : ev.clientX - x0;
      x0 = null;
      if (Math.abs(dx) >= LIMIAR) passo(dx < 0 ? 1 : -1);
    });
    gm.addEventListener('pointercancel', () => { x0 = null; });
    gm.addEventListener('dragstart', (ev) => ev.preventDefault());
  }

  /* vindo de um aro sem a empunhadura escolhida (?escolha=empunhadura): o texto no grupo, sem rolagem nem contorno */
  if (IT >= 0 && !S.tam && new URLSearchParams(location.search).get('escolha') === 'empunhadura') { S.pendente = true; renderTam(); }

  window.HitProduto = Object.freeze({
    get pronto() { return true; },
    aoAdicionar(fn) {
      if (typeof fn !== 'function') throw new TypeError('HitProduto.aoAdicionar(fn): fn tem de ser uma função');
      tratador = fn;
    },
    estado: () => ({ cor: S.cor, tam: S.tam, variante: atual() ? atual().id : null, barra: estado(), pendente: S.pendente }),
    variante: () => atual(),
    foto: fotoAtual,
    passo,
    irPara,
  });
})();
